import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-dispositivos-edit',
  templateUrl: './dispositivos-edit.component.html',
  styleUrl: './dispositivos-edit.component.css',
  standalone: false
})
export class DispositivosEditComponent implements OnInit {

  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema("device").subscribe((data) => {
      this.fields = data;
    });
  }
  public readonly serviceApi = environment.apiUrl + '/v1/devices';

  public readonly breadcrumb: PoBreadcrumb = {
    items: [{ label: 'Home', link: '/home' }, { label: 'Controle de Acesso' }, { label: 'Dispositivos', link: '/devices' }, { label: 'Edição' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
    save: 'devices',
    // saveNew: '/cliente',
  };

  fields: PoPageDynamicEditField[] = []
}

